// JavaScript source code
import React from "react";
import "./css/AboutUs.css"; // Reuse shared styles
import pictureOne from "./assets/picOne.png";

const ManagementSystemsCertification = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header management-header">
        <div className="overlay">
          <h1 className="page-title">Management Systems Certification</h1>
          <p className="subtitle">
            Building trust, efficiency, and competitiveness through certified management systems.
          </p>
        </div>
      </section>

      {/* === Introduction Section === */}
      <section className="intro-section">
        <div className="intro-card">
          <h2>About the Management Systems Certification Scheme</h2>
          <p>
            The Management Systems Certification (MSC) Scheme of the Malawi Bureau of Standards (MBS)
            provides independent third-party certification of organizations’ management systems to
            ensure compliance with international standards. The scheme supports organizations in
            improving efficiency, maintaining quality, ensuring environmental protection, and promoting
            occupational health and safety.
          </p>
        </div>

        <div className="intro-card">
          <h2>Our Commitment</h2>
          <p>
            The MBS is committed to offering impartial, credible, and value-adding certification services
            that enhance customer satisfaction, support compliance with regulatory requirements, and
            promote continuous improvement within organizations.
          </p>
        </div>
      </section>

      {/* === Types of Management Systems === */}
      <section className="functions-section">
        <h2>Management Systems We Certify</h2>
        <ul>
          <li>
            <strong>ISO 9001 – Quality Management Systems:</strong> Helps organizations consistently
            provide products and services that meet customer and regulatory requirements.
          </li>
          <li>
            <strong>ISO 22000 – Food Safety Management Systems:</strong> Ensures safe production,
            handling, and distribution of food along the supply chain.
          </li>
          <li>
            <strong>ISO 14001 – Environmental Management Systems:</strong> Encourages responsible
            environmental practices and sustainable use of resources.
          </li>
          <li>
            <strong>ISO 45001 – Occupational Health and Safety Management Systems:</strong> Enhances
            workplace safety and reduces risks related to occupational hazards.
          </li>
          <li>
            <strong>ISO 27001 – Information Security Management Systems:</strong> Protects the
            confidentiality, integrity, and availability of information assets.
          </li>
        </ul>
      </section>

      {/* === Benefits Section === */}
      <section className="benefits-section">
        <h2>Benefits of MBS Management Systems Certification</h2>
        <ul>
          <li>Improves organizational performance and operational efficiency.</li>
          <li>Enhances reputation and builds customer confidence.</li>
          <li>Facilitates compliance with regulatory and legal requirements.</li>
          <li>Opens access to regional and international markets.</li>
          <li>Encourages continual improvement and innovation.</li>
        </ul>
      </section>

      {/* === Background and Mandate === */}
      <section className="background-section">
        <div className="text-content">
          <h2>Background</h2>
          <p>
            The MBS established the Management Systems Certification Scheme in line with its mandate
            to promote quality assurance and standardization in Malawi. The scheme operates under the
            Standards Act and is managed by trained and accredited auditors who assess organizations
            for compliance with relevant ISO standards.
          </p>

          <h2>Mandate</h2>
          <p>
            To assess and certify management systems implemented by organizations in Malawi and beyond,
            providing formal recognition of compliance to international standards and fostering
            continuous improvement across industries.
          </p>
        </div>

        <div className="image-content">
          <img src={pictureOne} alt="MBS Management Systems Certification" />
        </div>
      </section>

      {/* === Accreditation Section === */}
      <section className="benefits-section">
        <h2>Accreditation and Recognition</h2>
        <p>
          The MBS Management Systems Certification Scheme is recognized nationally and regionally.
          MBS maintains alignment with international best practices through cooperation with bodies
          such as the Southern African Development Community Accreditation Service (SADCAS) and the
          International Organization for Standardization (ISO).
        </p>
      </section>
    </div>
  );
};

export default ManagementSystemsCertification;
